"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rpcDefaults = void 0;
exports.rpcDefaults = {
    id: '0',
    methodVersion: 1,
};
//# sourceMappingURL=rpc-defaults.js.map